import { connect } from 'react-redux';
import LearningAdminModulesGridScreen from '../components/LearningAdminModulesGridScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const defaultOrderModuleSeries = 'order.asc';
const defaultLimitModuleSeries = 20;
const defaultScope = 'list';

const moduleSerieTypes = [
  {
    action: 'recommended',
    value: true,
  },
  {
    action: 'recommended_not',
    value: false,
  },
];

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  let moduleSeriesIds = [];
  let recommendedSeriesIds = [];
  let moreContentSeriesIds = [];

  moduleSerieTypes.forEach((x) => {
    const results = [].concat.apply(
      [],
      Object.entries(
        state.learningsAdmin.getIn(
          [
            'moduleSeriesAdmin',
            defaultScope,
            partnershipId,
            x.action,
            'pages',
            defaultOrderModuleSeries,
            defaultLimitModuleSeries,
          ],
          {}
        )
      ).map(([k, v]) => v.toArray())
    );

    if (x.action === 'recommended') {
      recommendedSeriesIds.push(...results);
    } else if (x.action === 'recommended_not') {
      moreContentSeriesIds.push(...results);
    }

    moduleSeriesIds.push(...results);
  });

  let total = 0;
  let totalRecommended = 0;
  let totalMoreContent = 0;

  moduleSeriesIds.forEach((x) => {
    const moduleCount =
      state.learningsAdmin.getIn(
        ['modulesAdmin', defaultScope, partnershipId, x, 'totalModulesAdmin'],
        0
      ) || 0;

    total += moduleCount;

    if (recommendedSeriesIds.includes(x)) {
      totalRecommended += moduleCount;
    } else if (moreContentSeriesIds.includes(x)) {
      totalMoreContent += moduleCount;
    }
  });

  return {
    total,
    totalRecommended,
    totalMoreContent,
    moduleSerieTypes: moduleSerieTypes,
    defaultLimitModuleSeries,
    defaultOrderModuleSeries,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModulesGridScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModulesGridScreen);

export default LearningAdminModulesGridScreenContainer;
